import http from "../http-common";
import { publishingApi } from "../services/publishingApi";

// HTTP requests
//API NEEDS TO respond correctly

// used in ShowcaseList.jsx
const getAll = () => {
  return http.get("/books/all/7");
};

// used in Booklist.jsx
const getAllMinimal = () => {
  return http.get("/books/minimal/7");
};

const get = (id) => {
  return http.get(`/books/${id}/7`);
};

// used in MaterialAddBook.jsx
const create = (data) => {
  return http.post("/books", data);
};

// used in MaterialAddBook.jsx, EditBookDetails.jsx, Book.jsx, OldBook.jsx
const update = (id, data) => {
  return http.put(`/books/${id}`, data);
};

// used in MaterialAddBook.jsx, EditBookDetails.jsx, Book.jsx, OldBook.jsx, oldBookList.jsx
const remove = (id) => {
  return http.delete(`/books/${id}`);
};

// used in oldBookList.jsx
const removeAll = () => {
  return http.delete(`/books`);
};

// used in BookList.jsx, oldBookList.jsx
const findByTitle = (title) => {
  console.log("API calling find by title for: " + title);
  return http.get(`/books/search/${title}/7`);
};

// used in MaterialAddBook.jsx
const postCoverImage = (id, bookCoverData) => {
  return http.post(`/books/${id}/cover`, bookCoverData);
};

// used in MaterialAddBook.jsx
const uploadBookDescription = (id, data) => {
  return http.post(`/books/${id}/description`, data);
};

// used in MaterialAddBook.jsx
const getBookDescription = (id) => {
  return http.get(`books/${id}/description/download/7`);
};

// Coaching point methods
// used in ContentTab.jsx (which is in PropertiesMenu.jsx)
const uploadCoachingPointAudio = (bookId, language, file) => {
  return http.post(`/books/${bookId}/coaching/${language}/audio`, file);
};

// used in ContentTab.jsx (which is in PropertiesMenu.jsx)
const uploadCoachingPointSubtitles = (bookId, language, file) => {
  return http.post(`/books/${bookId}/coaching/${language}/subtitles`, file);
};

// used in WsComponent.jsx
const constructBookAudioLink = (bookId, link) => {
  return `https://d24hdgytax3x03.cloudfront.net/${bookId}/ChapterAudios/${link}`;
};

// not used anywhere yet?
// added by camern
const uploadBookPdf = (bookId, data) => {
  return http.post(`/books/${bookId}/pdf/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// used in UsageDataModal.jsx
const getBookUsage = (domainId) => {
  return http.get(`/getBookUsageDto/${domainId}`);
};

// used in UsageDataModal.jsx
const getUsageDataByMonth = (domainId, year, month) => {
  return http.get(
    `/getBookUsageByMonth/${domainId}/year/${year}/month/${month}`
  );
};

const getUsageDataByMonthNew = (year, month) => {
  return http.get(`/getBookUsageByMonth/${year}/${month}`);
};
const getUsageDataByDateRange = (startDate, endDate) => {
  return http.get(`/getBookUsageByDateRange/${startDate}/${endDate}`);
};

const addToPublishing = (bookId, data) => {
  return http.post("/publish/" + bookId, data);
};

const deleteFromPublishing = (bookId) => {
  return publishingApi.delete(`/books/${bookId}`);
};

const getPublishingData = (bookId) => {
  return publishingApi
    .get(`/books/${bookId}/authoring`)
    .then((res) => res.data)
    .catch((e) => {
      console.log(e);
    });
};
const getBookInfo = (bookId) => {
  return http.get(`/file/bookData/${bookId}`).catch((e) => e);
};

const cloneBook = (bookId) => {
  return http.post(`/file/clone/${bookId}`);
};
const getAllIBCData = () => {
  return http.get(`/api/cards`);
};
const BookDataService = {
  getAll,
  get,
  getPublishingData,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
  postCoverImage,
  getAllMinimal,
  uploadBookDescription,
  getBookDescription,
  uploadCoachingPointAudio,
  uploadCoachingPointSubtitles,
  constructBookAudioLink,
  uploadBookPdf,
  getBookUsage,
  getUsageDataByMonth,
  getUsageDataByDateRange,
  addToPublishing,
  deleteFromPublishing,
  getBookInfo,
  cloneBook,
  getUsageDataByMonthNew,
  getAllIBCData,
};

export default BookDataService;
